import React, { useEffect, useState } from "react";
import { Form, Input, Card, Typography, Spin } from "antd";
import axios from "axios";

const { Title } = Typography;

const UserDetailView = () => {
  const [userDetails, setUserDetails] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading spinner

  useEffect(() => {
    document.title = "JOJ | Account Details";
    getUserDetails();
  }, [userDetails.Count]);

  // const userDetails = {
  //   name: "Ravi Singh",
  //   companyName: "Rajputi Collection Pvt. Ltd.",
  //   address: "123, Royal Road, Jaipur",
  //   gstin: "08ABCDE1234F1Z5",
  //   city: "Jaipur",
  //   state: "Rajasthan",
  // };

  async function getUserDetails() {
    const token = localStorage.getItem("token");
    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      axios
        .request(config)
        .then((response) => {
          setUserDetails(response.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
    }
  }

  return (
    <Spin spinning={loading} tip="Loading user details...">
      {" "}
      {/* Spinner */}
      {userDetails ? (
        <Card
          style={{
            maxWidth: 600,
            margin: "0 auto",
            marginTop: 40,
            borderRadius: 12,
          }}
        >
          <Title level={3} style={{ textAlign: "center", marginBottom: 24 }}>
            User Details
          </Title>

          <Form layout="vertical">
            <Form.Item label="Name">
              <Input value={userDetails.OwnerName} disabled />
            </Form.Item>

            <Form.Item label="Company Name">
              <Input value={userDetails.FirmName} disabled />
            </Form.Item>

            <Form.Item label="Address">
              <Input value={userDetails.Address} disabled />
            </Form.Item>

            <Form.Item label="GSTIN">
              <Input value={userDetails.GSTIN} disabled />
            </Form.Item>

            <Form.Item label="City">
              <Input value={userDetails.City} disabled />
            </Form.Item>

            <Form.Item label="State">
              <Input value={userDetails.State} disabled />
            </Form.Item>
          </Form>
        </Card>
      ) : null}
    </Spin>
  );
};

export default UserDetailView;
